import React from 'react';

/**
 * Reusable SEO component for dynamic head metadata injection in React 19.
 * Leverage native hoisting: React 19 automatically hoists <title>, <meta>, and <link>
 * elements inside any component directly to the document <head>.
 */
const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonicalUrl, 
  ogImage, 
  ogType = 'website', 
  noIndex = false 
}) => {
  const defaultTitle = "Smart Interview | AI-Powered Tech Assessment & Proctoring";
  const defaultDesc = "Smart Interview Platform automates screenings, monitors candidate integrity with eye-tracking, and provides deep behavioral AI insight.";
  const defaultUrl = "https://smartinterviewplatform.com" + window.location.pathname;
  const defaultImage = "https://smartinterviewplatform.com/og_cover_banner.png";

  const finalTitle = title ? `${title} | Smart Interview` : defaultTitle;
  const finalDesc = description || defaultDesc;
  const finalUrl = canonicalUrl || defaultUrl;
  const finalImage = ogImage || defaultImage;

  return (
    <>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={finalUrl} />
      
      {/* Search crawler indexing instructions */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={finalImage} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImage} />
    </>
  );
};

export default SEO;
